// the above line makes the linter ignore Sys.* errors, Sys DOES exist, it is part of ASP.Net, but logically it does NOT exist 'here'
// requires for external dependencies and other global stuff go here
/* eslint-disable no-unused-vars */

import helper from './util/helper';
import Lazysizes from 'lazysizes';

import Swiper from '../Scripts/modules/swiper/swiper.module';
import brands from '../Scripts/modules/brands/brands.module';
import collapse from '../Scripts/modules/collapse/collapse.module';
import eventListeners from '../Scripts/modules/eventlisteners/eventlisteners.module';
import floatingLabels from '../Scripts/modules/forms/forms.module';
import gallery from '../Scripts/modules/gallery/gallery.module';
import goToPage from '../Scripts/modules/paging/paging.module';
import gridLayout from '../Scripts/modules/grid/grid.module';
import linkConverter from '../Scripts/modules/linkconverter/linkconverter.module';
import nav from '../Scripts/modules/nav/nav.module';
import table from '../Scripts/modules/table/table.module';
import scrolling from '../Scripts/modules/scrolling/scrolling.module';
import scrollspy from '../Scripts/modules/scrollspy/scrollspy.module';

import './util/polyfill';

// import $ from 'jquery';
// import Vue from 'vue';
// import Vuex from 'vuex';

/**
 * Bootstrap - Import ONLY if necessary
 **/
// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/index';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/tooltip';
// import 'bootstrap/js/dist/util';

/* eslint-enable no-unused-vars */

// make sure Promise is present
// require('es6-promise/auto');

// Init function, can be used for startup stuff
function init() {
    floatingLabels();
    gridLayout();
    collapse();
    Swiper();
    linkConverter();
    eventListeners();
    table();
    gallery();
    nav();
    brands();
}

export default {
    init
};
